import { CheckoutQuery as SourceCheckoutQuery } from 'SourceQuery/Checkout.query';
import { Field } from 'Util/Query';

export class CheckoutQuery extends SourceCheckoutQuery {

    _getEstimatedShippingFields() { // added 'delivery_days' + 'selected'
        return [
            'amount',
            'available',
            'base_amount',
            'method_code',
            'carrier_code',
            'method_title',
            'carrier_title',
            'error_message',
            'price_excl_tax',
            'price_incl_tax',
            'delivery_days'
        ];
    }

    getRestrictedShippingMessage(countryId, guestCartId) {
        const query = new Field('getRestrictedShippingMessage')
            .addArgument('countryId', 'String!', countryId)
            .addFieldList(['error_message']);

        this._addGuestCartId(guestCartId, query);

        return query;
    }

    getPlaceOrderMutation(input) {
        const mutation = new Field('s_placeOrder')
            .addArgument('input', 'GiftWrapInput', input)
            .setAlias('placeOrder')
            .addField(this._getOrderField());

        return mutation;
    }

    // payu
    getPayU(order_id, browser_data_json = '', token_used = '', save_token = false) {
        return new Field('getPayuData')
            .addArgument('order_id', 'String', order_id)
            .addArgument('browser_data_json', 'String', browser_data_json)
            .addArgument('token_used', 'String', token_used)
            .addArgument('save_token', 'Boolean', save_token)
            .addFieldList(this._getPayUFields());
    }

    // payu
    getPayuSaveCard() {
        return new Field('getPayuSaveCard')
            .addFieldList(['status', 'continueUrl']);
    }

    getRetryPayu(orderIncrementId, ctrl) {
        return new Field('getRetryPayuData')
            .addArgument('reference', 'String', orderIncrementId)
            .addArgument('ctrl', 'String', ctrl)
            .addFieldList(this._getPayUFields());
    }

    _getPayUFields() {
        return [
            'payu_json'
        ]
    }

    // 2performant
    getTwoPerformant(orderID) {
        const order_increment_id = orderID;

        return new Field('getTwoPerformantLink')
            .addArgument('order_increment_id', 'String', order_increment_id)
            .addField('link')
    }

    // bank transfer instructions
    _getPaymentMethodFields() {
        return ['code', 'title', 'instructions'];
    }
}

export default new CheckoutQuery();
